import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    inputStyle: {
        " & input": {
            fontSize: "14px",
            fontFamily: "Open Sans",
            padding: "5px !important",
        },
        "&.MuiFormControl-root": {
            paddingTop: "20px",
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            background: theme.palette.secondary.main,
        },
    },
    tooltipDisplayNone: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            display: "none",
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            borderBottom: "1px solid rgba(193, 200, 218, 1)",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: theme.spacing(1),
            wordBreak: "break-word",
        },
    },
}));
